import { twMerge } from "tailwind-merge";

const SELLAR_X_TWO_SIGNATURE_SRC =
  "https://sellar.imgix.net/sellar-image-assets/app-assets/sellarxtwo-signature.svg";

export const SellarCreditTwoSignature = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <img
      src={SELLAR_X_TWO_SIGNATURE_SRC}
      alt="Sellar x Two"
      width={140}
      height={35}
      className={twMerge("mt-auto w-[140px] shrink-0 pt-6", className)}
    />
  );
};
